<template>
  <div>
    <el-card class="container">
      <el-col :span="9" align="center" class="divColumn">
        <div class="serverItem">
          <img src="@/assets/u371.png"/>
        </div>
        <!-- <div class="serverItem">
            <i class="el-icon-bottom-right" style="font-weight: bold;color: #e8d015;"></i>
            {{server.innerip}}
        </div>
        <div class="serverItem">
            <i class="el-icon-top-left" style="font-weight: bold;color: rgb(77, 236, 27);"></i>
            {{server.outerip}}
        </div> -->
        <div class="serverItem">
          <el-button size="mini" type="primary" @click="showIpInfo"
                     v-if="listOperations.some(func => func.name.includes('device_IP'))">查看IP</el-button>
        </div>
        <div class="serverItem">
          <div style="text-align: center;">设备：{{ server.name }}</div>
          <div style="text-align: center;">机房：{{ server.room }}</div>
        </div>
      </el-col>
      <el-col :span="8" align="center" class="divColumn">
        <!--                <div class="item">-->
        <!--                    <label class="columnLabel">负载</label>-->
        <!--                    <div class="columnContent">-->
        <!--                        <el-progress :text-inside="true" :stroke-width="20" status="success" :percentage="server.load"></el-progress>-->
        <!--                    </div>-->
        <!--                </div>-->
        <div class="item">
          <label style="margin-right: 4px;">CPU</label>
          <div class="columnContent">
            <el-progress :text-inside="true" :stroke-width="20" status="success"
                         :percentage="server.load.cpuUsage"></el-progress>
          </div>
        </div>
        <div class="item">
          <label style="margin-right: 4px;">内存</label>
          <div class="columnContent">
            <el-progress :text-inside="true" :stroke-width="20" status="success"
                         :percentage="server.load.memUsage"></el-progress>
          </div>
        </div>
        <div class="item">
          <label style="margin-right: 4px;">网络</label>
          <div class="columnContent alignLeft">
            <i class="el-icon-top" style="color:#E6A23C;"></i><span>{{ server.load.uploadBw }}</span>
            <i class="el-icon-bottom"
               style="color:#409EFF;margin-left: 2px;"></i><span>{{ server.load.downloadBw }}</span>
          </div>
        </div>
        <!--                <div class="item">-->
        <!--                    <label style="margin-right: 4px;">磁盘</label>-->
        <!--                    <div class="columnContent alignLeft">-->
        <!--                        {{server.disk}}-->
        <!--                    </div>-->
        <!--                </div>-->
        <div class="item">
          <label style="margin-right: 4px;">磁盘</label>
          <div class="columnContent">
            <el-progress :text-inside="true" :stroke-width="20" status="success"
                         :percentage="server.load.diskStorage"></el-progress>
          </div>
        </div>
      </el-col>
<!--      <el-col :span="3" align="center" class="divColumn">-->
<!--        <div style="margin-bottom: 14px;">健康值</div>-->
<!--        <div class="heartBreak" v-if="server.healthy == 0">离线</div>-->
<!--        <div class="heartConnect" v-else>{{ server.healthy }}</div>-->
<!--      </el-col>-->
      <el-col :span="6" align="center" class="divColumn columnSelf">
        <!-- <div class="item">
            <label class="">网元类型：{{server.networkunittype}}个</label>
            <i class="el-icon-s-promotion operateIcon" @click="goPage('nettype', server.networkunittype)"></i>
        </div> -->
        <div class="item">
          <label class="">模块类型：{{ server.moduleTypeList ? server.moduleTypeList.length : 0 }}个</label>
          <i class="el-icon-s-promotion operateIcon" @click="goPage('module', server)"
             v-if="listOperations.some(func => func.name.includes('device_moduleType'))"></i>
        </div>
        <!-- <div class="item">
            <label class="">网元实例：{{server.moduletype}}个</label>
            <i class="el-icon-s-promotion operateIcon" @click="goPage('netinstance', server.moduletype)"></i>
        </div> -->
        <div class="item">
          <label class="">模块实例：{{ server.insCount }}个</label>
          <i class="el-icon-s-promotion operateIcon" @click="goPage('instance', server)"
             v-if="listOperations.some(func => func.name.includes('device_moduleIns'))"></i>
        </div>
      </el-col>
    </el-card>

    <el-dialog :title="server.name" :visible="showIpList" @close="showIpList=false">
      <el-form inline>
        <div v-for="(item, index) in server.networkCards" :key="index">
          <el-form-item label="内网ip:" style="width:30%;">
            <span>{{ item.innerNetwork.ip }}</span>
          </el-form-item>
          <el-form-item label="外网ip:">
            <span>{{ item.outerNetwork.ip }}</span>
          </el-form-item>
        </div>

        <div style="text-align:center;">
          <el-button @click="showIpList=false">关闭</el-button>
        </div>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'ServerCard',
  props: {
    server: {
      type: Object,
      default: {}
    },
    listOperations:{
      type:Array
    }
  },
  data: vm => ({
    showIpList: false,
  }),
  methods: {
    showIpInfo() {
      this.showIpList = true;
    },
    // 跳转页面
    goPage(name, server) {
      let pathName = ''
      const routePath = this.$route.path
      if (Object.keys(server).length == 0) {
        this.$message.warning('没有相关内容')
        return
      }
      if (!name) {
        return
      }
      if (name == 'module') {
        if (routePath.startsWith('/monitor')) {
          pathName = 'monitormodule'
        } else {
          pathName = 'monitormoduletype'
        }
      } else {
        if (routePath.startsWith('/monitor')) {
          pathName = 'monitorinstance'
        } else {
          pathName = 'monitormoduleinstance'
        }
      }
      this.$router.push({
        name: pathName,
        params: {
          device: {
            id: server.deviceId,
            name: server.name,
          },
          moduleStat: server.moduleTypeList
        }
      })
    }
  }
}
</script>

<style scoped>
.alignLeft {
  text-align: left;
}

.container {
  padding: 6px;
}

.container >>> .el-card__body {
  padding: 0;
}

.divColumn {
  border-right: 1px dotted #ccc;
  height: 150px;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.divColumn >>> .el-progress-bar__outer,
.divColumn >>> .el-progress-bar__inner {
  border-radius: 0;
}

.columnLabel {
  margin-right: 4px;
}

.columnContent {
  display: inline-block;
  width: 70%;
}

.serverItem {
  padding: 8px;
}

.columnSelf {
  border: none;
}

.item {
  display: flex;
  justify-content: space-between;
  padding: 8px;
}

.heartBreak {
  color: red;
  font-size: 24px;
  font-weight: bold;
}

.heartConnect {
  color: #67C23A;
  font-size: 24px;
  font-weight: bold;
}

.operateIcon {
  cursor: pointer;
  color: #5cb6ff;
  font-size: 20px;
}
</style>
